import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

const when = (s) => String(s).slice(0, 16).replace("T", " ");

export function ConflictDialog({ list, onClose, onConfirm, busy }) {
  return (
    <Dialog open={!!list} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-white max-w-lg" data-testid="hours-conflicts">
        <DialogHeader><DialogTitle>{list?.length} upcoming booking{list?.length === 1 ? "" : "s"} fall outside the new hours</DialogTitle>
          <DialogDescription>These bookings will stay exactly as they are — nothing is cancelled or moved. Contact the customers if you need to reschedule.</DialogDescription></DialogHeader>
        <ul className="max-h-60 space-y-1 overflow-y-auto text-sm">{(list || []).slice(0, 50).map((b) => <li key={b.id} className="flex justify-between rounded border border-slate-100 px-2 py-1" data-testid={`hours-conflict-${b.id}`}><span>{b.service_name || "Booking"}</span><span className="text-slate-500">{when(b.start_time)} · {b.status}</span></li>)}</ul>
        <DialogFooter><Button variant="outline" onClick={onClose} data-testid="hours-conflicts-back">Go back</Button><Button className="bg-slate-900 text-white" disabled={busy} onClick={onConfirm} data-testid="hours-conflicts-confirm">Save anyway</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
